import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AppSharedModule } from 'src/app/app-shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes = [{ path: '', component: DashboardComponent }];

const COMPONENTS = [DashboardComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    AppSharedModule,
    InlineSVGModule.forRoot(),
    RouterModule.forChild(routes),
    TranslateModule.forChild({
      extend: true
    })
  ],
  providers: [NgbActiveModal]
})
export class DashboardModule {}
